import { hlcFormat, hlcInit, hlcReceive, hlcTick, type Hlc, type HlcState } from '@odhaczka/core';
import { v7 as uuidv7 } from 'uuid';
import { db, getMeta } from './db';

// Zegar urządzenia: identyfikator urządzenia, HLC i licznik odhaczeń.
// Stan trzymany w pamięci i zapisywany do tabeli meta w tej samej transakcji co zmiana.
let deviceId = '';
let state: HlcState | null = null;
let seq = 0;

export async function initClock(): Promise<void> {
  deviceId = (await getMeta<string>('deviceId')) ?? uuidv7();
  state = (await getMeta<HlcState>('hlc')) ?? hlcInit(deviceId);
  seq = (await getMeta<number>('seq')) ?? 0;
  await db.meta.bulkPut([
    { key: 'deviceId', value: deviceId },
    { key: 'hlc', value: state },
    { key: 'seq', value: seq },
  ]);
}

function ensure(): HlcState {
  if (!state) throw new Error('Zegar nie został zainicjalizowany (initClock)');
  return state;
}

export function getDeviceId(): string {
  ensure();
  return deviceId;
}

/** Wołać wewnątrz transakcji Dexie obejmującej tabelę meta. */
export async function tick(): Promise<Hlc> {
  const [hlc, next] = hlcTick(ensure(), Date.now());
  state = next;
  await db.meta.put({ key: 'hlc', value: state });
  return hlc;
}

/** Kolejny numer odhaczenia na tym urządzeniu. Wołać wewnątrz transakcji z tabelą meta. */
export async function nextSeq(): Promise<number> {
  seq += 1;
  await db.meta.put({ key: 'seq', value: seq });
  return seq;
}

/** Uwzględnia znaczniki z serwera, żeby lokalne zmiany zawsze były późniejsze. */
export async function observe(remote: Hlc): Promise<void> {
  const s = ensure();
  if (remote <= hlcFormat(s.wallMs, s.counter, s.node)) return;
  state = hlcReceive(s, remote, Date.now());
  await db.meta.put({ key: 'hlc', value: state });
}
